import { useMemo } from "react";
import { parseProspectDatafields } from "../../../leadsTracking/utils";
import { IconUser } from "@tabler/icons-react";
import Selector from "../../../../../components/Selectors/Selector";

function getOptionName(option, actionType) {  
  let contact = parseProspectDatafields(option);

  let firstName =
    contact?.properties?.find(
      (x) => x.identifier_placeholder === "%first_name%"
    )?.value || " - ";

  let lastName =
    contact?.properties?.find((x) => x.identifier_placeholder === "%last_name%")
      ?.value || " - ";

  let email = contact?.properties?.find(
    (x) => x.identifier_placeholder === "%email%"
  )?.value;

  let linkedin = contact?.properties?.find(
    (x) => x.identifier_placeholder === "%linkedin_url%"
  )?.value;

  let phone = contact?.properties?.find(
    (x) => x.identifier_placeholder === "%phone%"
  )?.value;

  let getAdditional = () => {
    if (actionType === "email") {
      return email;
    }
    if (actionType?.includes("linkedin")) {
      return linkedin;
    }
    return phone;
  };

  return `${firstName} ${lastName} ${
    getAdditional() ? `( ${getAdditional()} )` : ""
  }`;
}

const ContactPreview = ({
  loading,
  contact,
  contacts,
  setContact,
  actionType,
}) => {
  const options = useMemo(() => {
    let result = [{ label: "Contacts", options: [] }];
    contacts?.forEach((account) => {
      result[0].options.push({
        ...account,
        option_name: getOptionName(account, actionType),
      });
    });
    return contacts.length > 0 ? result : [];
  }, [contacts, actionType]);

  return (
    <Selector
      leftSection={<IconUser size={18} />}
      onChange={setContact}
      options={options}
      size={"md"}
      value={contact?.id}
      offset={0}
      unclearable
      getOptionName={(o) => getOptionName(o, actionType)}
      loading={loading}
    />
  );
};

export default ContactPreview;
